import {REMARK_SUCCESS, REMARK_ERROR} from '../actions/remark';

const initialState = {
    data: '',
    error: null
};

export default function reducer(state = initialState, action) {
    if (action.type === REMARK_SUCCESS) {
        return Object.assign({}, state, {
            data: action.data,
            error: null
        });
    } else if (action.type === REMARK_ERROR) {
        return Object.assign({}, state, {
            error: action.error
        });
    }
    return state;
}